module.exports = __webpack_public_path__ + "media/images/landing_side_readers-bf82555d6a0d1373806caba91678e7fd.jpg";